import { _ as y, a as T } from "../tslib.es6-CkJbB1D2.mjs";
import { C as P, a as E } from "../TryTemplateButton-CT-RZ-s3.mjs";
var b = function() {
  var m = function(e) {
    return y(void 0, [e], void 0, function(s) {
      var a, r, n, t, i, u, c, l, f = s.templateSlug, v = s.shouldUseTemplateAPIExecute, h = s.url, w = h === void 0 ? window.location.href : h;
      return T(this, function(o) {
        switch (o.label) {
          case 0:
            return o.trys.push([0, 3, , 4]), [4, fetch("/api/templates/execute", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                templateSlug: f,
                url: w,
                shouldUseTemplateAPIExecute: v
              })
            })];
          case 1:
            return a = o.sent(), [4, a.json()];
          case 2:
            if (r = o.sent(), !a.ok)
              throw n = a.status, t = r.errors ? r.errors[0] : (l = (c = r.responseBody) === null || c === void 0 ? void 0 : c.errors) === null || l === void 0 ? void 0 : l[0], t?.code === "service:unknown" ? new Error("Failed to execute (status: ".concat(n, ") ").concat(t.error)) : t || new Error("HTTP ".concat(n));
            return i = new URL(r.redirectTo, window.location.origin), i.searchParams.set(P, E), window.location.href = i.href, [3, 4];
          case 3:
            throw u = o.sent(), console.error("Template execution error:", u), u;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, p = "Something went wrong while trying to use this template.", d = function(e) {
    switch (e.code) {
      case "tables:limits:too_many_tables":
      case "limits:too_many_tables":
        return "You have reached the limit of Tables for your plan. Please upgrade your plan to create more.";
      case "limits:projects":
      case "interfaces:limits:projects":
        return "You have reached the limit of Interfaces for your plan. Please upgrade your plan to create more.";
      case "limits:chatbots":
      case "chatbots:limits:chatbots":
        return "You have reached the limit of Chatbots for your plan. Please upgrade your plan to create more.";
      case "upstream-error":
        return e.title === "GulliverApiError" && (e.status === "426" || e.status === "402") ? "This template contains Zap(s) that includes features (steps, paths, premium apps) not covered by your plan. Please upgrade your plan to use this template." : p;
      default:
        return p;
    }
  };
  return { executeTemplate: m, formatExecutionError: d };
};
export {
  b as useExecuteTemplate
};
//# sourceMappingURL=useExecuteTemplate.es.js.map
